import { predicateNumber } from 'utilities/isType.js';
import { StatusRating } from 'utilities/status/status-rating.js';

export const getBBQRatingName = (rating: number): string | undefined => {
  if (rating === 1) {
    return 'Not Today';
  }
  if (rating === 2) {
    return 'A Bit Iffy';
  }
  if (rating === 3) {
    return 'Looking Good';
  }
  if (rating === 4) {
    return 'Perfect for Outdoors';
  }
};

export const getBBQRatingClass = (rating?: number): string => {
  if (predicateNumber(rating)) {
    if (rating === 1) {
      return StatusRating.statusBad;
    }
    if (rating === 2) {
      return StatusRating.statusMedium;
    }
    if (rating === 3) {
      return StatusRating.statusMediumGood;
    }
    if (rating === 4) {
      return StatusRating.statusGood;
    }
  }
  return StatusRating.statusNone;
};

export const getBBQRatingTextClass = (rating?: number): string => {
  if (predicateNumber(rating)) {
    if (rating === 1) {
      return 'warning-state-red';
    }
    if (rating === 2) {
      return 'warning-state-orange';
    }
    if (rating === 3) {
      return 'warning-state-blue';
    }
    if (rating === 4) {
      return 'warning-state-green';
    }
  }
  return 'warning-state-default';
};
